import React, { useState } from 'react'
import AylaResponseScrollArea from '../../ShortCourses/AylaResponseScrollArea'
import { useAiResponseStream } from './useAiResponseStream'

const MeetAyla = () => {
  const [displayedText, setDisplayedText] = useState('')
  const showCursor = displayedText.length <= 0
  const [index, setIndex] = useState(0)
  const { aiResponse, aiStreamComplete, setAiStreamComplete } =
    useAiResponseStream()

  const transformAylaResponse = (response) => {
    const urlRegex = /((https?:\/\/|www\.)[^\s]+)/g
    return response.replace(urlRegex, (url) => {
      const formattedUrl = url.startsWith('http') ? url : `https://${url}`
      return `<a href="${formattedUrl}" target="_blank" rel="noopener noreferrer">${formattedUrl}</a>`
    })
  }

  return (
    <AylaResponseScrollArea
      showBorder={true}
      showCursor={showCursor}
      aylaResponse={aiResponse}
      typingComplete={aiStreamComplete}
      setTypingComplete={setAiStreamComplete}
      displayedText={
        aiStreamComplete
          ? transformAylaResponse(displayedText).replace(/\n/g, '<br>')
          : displayedText.replace(/\n/g, '<br>')
      }
      setDisplayedText={setDisplayedText}
      index={index}
      setIndex={setIndex}
      className="!mt-0 mb-4 h-64"
    ></AylaResponseScrollArea>
  )
}

export default MeetAyla
